export function mapLookupsToListingData(
  lookups: any[],
  pageNumber: number,
  pageSize: number
) {
  const start = pageNumber * pageSize;
  const paged = lookups.slice(start, start + pageSize);
  return {
    pagedItems: paged.reduce((acc, curr) => {
      acc[curr.id] = curr;
      return acc;
    }, {}),
    pageNumber,
    pageSize,
    totalCount: lookups.length,
  };
}
